import { render, staticRenderFns } from "./UserSayCard.vue?vue&type=template&id=147a1f48&scoped=true&"
import script from "./UserSayCard.vue?vue&type=script&lang=ts&"
export * from "./UserSayCard.vue?vue&type=script&lang=ts&"
import style0 from "./UserSayCard.vue?vue&type=style&index=0&id=147a1f48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147a1f48",
  null
  
)

export default component.exports